import { DataEntryVehicleStepProps, typedMemo } from "src/types";
import { useDataEntryVehicleStep } from "./data-entry-vehicle-step.hook";
import { AccordionWrapperForm } from "src/ui/widgets";
import { DataEntryVehicleStepVehicle } from "./sections/vehicle/vehicle-step-vehicle-section";
import { DataEntryVehicleStepInsuranceCompany } from "./sections/insurance-company/vehicle-step-insurance-company";
import { DataEntryVehicleStepDriver } from "./sections/driver/vehicle-step-driver";
import { DataEntryVehicleStepOwner } from "./sections/owner/vehicle-step-owner";
import { DataEntryVehicleStepVehicleDamages } from "./sections/vehicle-damages/vehicle-step-vehicle-damages";
import { DataEntryVehicleStepContractor } from "./sections/contractor/vehicle-step-contractor";

export const DataEntryVehicleStep = typedMemo(
  (props: DataEntryVehicleStepProps) => {
    const { vehicleStepTitle, formikFieldBaseNameForSections, subject, t } =
      useDataEntryVehicleStep(props);
    const {
      step,
      formikVehicleValues,
      formikVehicleErrors,
      formikVehicleTouched,
      formik,
      validationSchema,
    } = props;

    const Title = (
      <div className="title-xs--700 mb-2">
        {t("data_entry.vehicle_step.title", {
          vehicle: vehicleStepTitle,
          subject: subject,
        })}
      </div>
    );

    const Body = (
      <div>
        <AccordionWrapperForm
        sectionKey="vehicleInfo"
          children={
            <DataEntryVehicleStepVehicle
              step={step}
              formikFieldBaseName={formikFieldBaseNameForSections}
              formikVehicleValues={formikVehicleValues}
              formikVehicleTouched={formikVehicleTouched}
              formikVehicleErrors={formikVehicleErrors}
              formik={formik}
              validationSchema={validationSchema}
            />
          }
          title={t("commons.vehicle")}
        />
        <AccordionWrapperForm
        sectionKey="contractor"
          children={
            <DataEntryVehicleStepContractor
              formikFieldBaseName={formikFieldBaseNameForSections}
              formikVehicleValues={formikVehicleValues}
              formikVehicleTouched={formikVehicleTouched}
              formikVehicleErrors={formikVehicleErrors}
              formik={formik}
              validationSchema={validationSchema}
            />
          }
          title={t("data_entry.vehicle_step.section_contractor_title")}
        />
        <AccordionWrapperForm
          sectionKey="company"
          children={
            <DataEntryVehicleStepInsuranceCompany
              formikFieldBaseName={formikFieldBaseNameForSections}
              formikVehicleValues={formikVehicleValues}
              formikVehicleTouched={formikVehicleTouched}
              formikVehicleErrors={formikVehicleErrors}
              formik={formik}
              validationSchema={validationSchema}
            />
          }
          title={t("data_entry.vehicle_step.section_insurance_company_title")}
        />
        <AccordionWrapperForm
          sectionKey="driver"
          children={
            <DataEntryVehicleStepDriver
              formikFieldBaseName={formikFieldBaseNameForSections}
              formikVehicleValues={formikVehicleValues}
              formikVehicleTouched={formikVehicleTouched}
              formikVehicleErrors={formikVehicleErrors}
              formik={formik}
              validationSchema={validationSchema}
            />
          }
          title={t("data_entry.vehicle_step.section_driver_title")}
        />
        <AccordionWrapperForm
          sectionKey="owner"
          children={
            <DataEntryVehicleStepOwner
              formikFieldBaseName={formikFieldBaseNameForSections}
              formikVehicleValues={formikVehicleValues}
              formikVehicleTouched={formikVehicleTouched}
              formikVehicleErrors={formikVehicleErrors}
              formik={formik}
              validationSchema={validationSchema}
            />
          }
          title={t("data_entry.vehicle_step.section_owner_title")}
        />
        <AccordionWrapperForm
          sectionKey="vehicleDamages"
          children={
            <DataEntryVehicleStepVehicleDamages
              step={props.step}
              formikFieldBaseName={formikFieldBaseNameForSections}
              formikVehicleValues={formikVehicleValues}
              formikVehicleTouched={formikVehicleTouched}
              formikVehicleErrors={formikVehicleErrors}
              formik={formik}
              validationSchema={validationSchema}
            />
          }
          title={t("data_entry.vehicle_step.section_vehicle_damages_title")}
        />
      </div>
    );

    return (
      <div>
        {Title}
        {Body}
      </div>
    );
  }
);
